import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useState } from "react";
import { ResendModal } from "../../../../return/return-modals/resend-modal";
import { useAskRedoReturnQuery } from "./use-ask-redo-return-query";

interface ResendReturnLabelInput {
  returnId?: string;
  reason?: string | null;
}

function readInput(input: unknown): ResendReturnLabelInput {
  return typeof input === "object" && input !== null ? input : {};
}

export interface ResendLabelCardProps {
  input: unknown;
  toolCallId: string;
  disabled: boolean;
}

export const ResendLabelCard = memo(function ResendLabelCard({
  input,
  disabled,
}: ResendLabelCardProps) {
  const args = readInput(input);
  const returnId = args.returnId;
  const [modalOpen, setModalOpen] = useState(false);
  const returnQuery = useAskRedoReturnQuery(returnId, "askRedoResendReturn");

  if (!returnId) {
    return null;
  }

  return (
    <Flex dir="column" gap="sm" pb="md" w="full">
      {args.reason ? (
        <Text fontSize="sm" textColor="secondary">
          {args.reason}
        </Text>
      ) : null}
      {returnQuery.isError ? (
        <Text fontSize="sm" textColor="error">
          Couldn&apos;t load this return&apos;s label details.
        </Text>
      ) : (
        <RedoButton
          disabled={disabled || returnQuery.isLoading || !returnQuery.data}
          hierarchy="primary"
          onClick={() => setModalOpen(true)}
          pending={returnQuery.isLoading}
          size="md"
          text="Review & send label"
        />
      )}
      {returnQuery.data ? (
        <ResendModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          return_={returnQuery.data}
        />
      ) : null}
    </Flex>
  );
});
